import React from 'react';
import { Row, Col } from 'react-bootstrap';
import FiuBlue from '../../../assets/images/default.svg';
var _ = require('lodash')

const News = (props) => {
  let newsRows = _.chunk(props.feed, 2);
  let imageItem;

  return (
    <Row className="news-section">
      <Col className="news-wrapper" sm={12}>
        <div className="title-news-wrapper">
          <h2 className="title-news-section">
            News
          </h2>
        </div>
        <Row className="body-news-section">
          {newsRows && newsRows.map((newsItem, key) => {

            return (
              <Row key={`news-section-${key}`}>
                {newsItem && newsItem.map((item, key) => {
                  imageItem = item.image !== '' ? item.image : FiuBlue;

                  return (
                    <Col className="new" key={`news-${key}`} sm={6}>
                      <div className="body-news-link" style={{ backgroundImage: `url(${FiuBlue})` }}>
                        <a target="_blank" href={item.url} rel="noopener noreferrer">
                          <img className="new-image" src={imageItem} alt="" />
                        </a>
                      </div>
                      <div className="body-new">
                        <a target="_blank" href={item.url} rel="noopener noreferrer">
                          <h3 className="new-title">
                            {item.title}
                          </h3>
                        </a>
                        <p className="new-description">
                          {item.description}
                        </p>
                      </div>
                    </Col>
                  )
                })}
              </Row>
            )
          })}
        </Row>
      </Col>
      <div className="all-news-wrapper">
        <a className="all-news" target="_blank" rel="noopener noreferrer" href="https://news.fiu.edu/">View all News</a>
      </div>
    </Row>
  )
}

export default News;



// WEBPACK FOOTER //
// ./src/app/screens/landing/news.js